// Copyright (c) 2019 Deere & Company

import './index.scss';
import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import {
    addPartToFunctionCode, deletePartNumber, editPartNumber, getAdminReport,
    getAdminReportDownload, getFunctionCode, getPartNumber,
} from '../../repositories';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
//import CSVFile from '../../../assets/function_code.csv';
import { ConfirmationModal } from '../../../shared/components/modals/confirmation-modal';
import FCMAside from './aside';
import FCMTable from './2-table-column';
import FunctionCodePanel from '../function-code-input-panel';
// import MultipleEntryPopup from './multiple-entry-popup';
import PartNumberSerchResultPanel from '../part-number-search-result-panel';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { customizeErrorAlert } from '../../../shared/services/customize-error-alert-bar';
import { getProductSeries } from '../../../app/common/repositories';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';
import FunctionCodeMultipleEntryPopup from './function-code-multiple-entry-popup';
import { downloadSampleReports } from '../../../claims/repositories';


export class FunctionCodeMaintenance extends Component {

    state = {
        functionCodes: [],
        productSeries: [],
        isEdit: false,
        isAdd: false,
        mode: '',
        // editText: '',
        confirmMessage: '',
        confirmTitle: '',
        confirmIsOpen: false,
        searchKeyFields: {
            productSeries: 0,
            functionCode: '',
            partNumber: '',
            manufacturingModule: '',
            designTeamCode: '',
            modelIsOpen: false,
            modelIsClose: false,

        },
        selectedPartNumber: {},
        hasSearched: false,
    };

    componentWillMount = () => {

        this.loadDefault();

    }


    componentDidMount () {

        if ( this.props.factoryCode ) {

            this.updateProductSeriesDropdown();

        }

    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.reload === 'functionCode' ) {

            this.loadDefault();
            this.updateProductSeriesDropdown();
            nextProps.updateReload();

        }

    }

    loadDefault = () => {

        this.setState( {
            isEdit: false,
            hasSearched: false,
            productSeries: [],
            searchKeyFields: {
                productSeries: 0,
                functionCode: '',
                partNumber: '',
                manufacturingModule: '',
                designTeamCode: '',
            },
            mode: '',

        } );

    }

    componentDidUpdate = prevProps => {

        if ( prevProps.factoryCode !== this.props.factoryCode ) this.updateProductSeriesDropdown();

    }

    handleProductSeriesChange = id => {

        const fc = this.state.searchKeyFields;
        fc.productSeries = id === '-1' ? 0 : id;
        this.setState( {
            searchKeyFields: fc,
        } );

    };

    handleAsideProductSeriesChange = obj => {

        const fc = this.state.selectedPartNumber;
        fc.productSeriesId = obj;
        this.setState( {
            selectedPartNumber: fc,
        } );

    };

    handleMainTextChange = event => {

        const desired = event.target.value.replace( /[^\w\s]/gi, '' ).trim();
        const searchKeyFields = { ...this.state.searchKeyFields };
        searchKeyFields[event.target.name] = desired;
        this.setState( { searchKeyFields } );

    };

    handleAddClick = () => {

        this.setState( {
            isEdit: true,
            isAdd: true,
            mode: '',
            selectedPartNumber: {
                productSeries: 0,
                functionCode: '',
                partNumber: '',
                manufacturingModule: '',
                designTeamCode: '',
            },
        } );

    };

    handleCancelClick = () => {

        this.setState( {
            isEdit: false,
            isAdd: false,
            searchKeyFields: {},
        } );

    }

    handleFunctionCodeSelect = searchKeyFields => {

        const fc = {
            productSeries: searchKeyFields.productSeriesId,
            functionCode: searchKeyFields.functionCodeName,
        };
        this.props.increaseCounter();
        getPartNumber( this.props.factoryCode, fc ).then( response => {

            this.setState( {
                functionCodes: response,
                mode: 'FIVECOLTABLE',
                selectedPartNumber: {},
                isEdit: false,
                isAdd: false,
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    };

    handleSearchClick = () => {

        if (
            ( this.state.searchKeyFields.productSeries !== 0
            || this.state.searchKeyFields.functionCode )
          && ( !this.state.searchKeyFields.partNumber &&
        !this.state.searchKeyFields.manufacturingModule &&
        !this.state.searchKeyFields.designTeamCode )
        ) {

            if ( this.state.searchKeyFields.productSeries === 0 ) {

                customizeErrorAlert( 'Please Select Product Series to Search for Function Code' );
                return false;

            }

            this.props.increaseCounter();
            getFunctionCode( this.props.factoryCode, this.state.searchKeyFields )
                .then( response => {

                    this.setState( {
                        functionCodes: response,
                        isEdit: false,
                        isAdd: false,
                        hasSearched: true,
                        mode: 'TWOCOLTABLE',
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        } else {

            this.props.increaseCounter();
            getPartNumber( this.props.factoryCode, this.state.searchKeyFields ).then( response => {

                this.setState( {
                    functionCodes: response,
                    isEdit: false,
                    isAdd: false,
                    hasSearched: true,
                    mode: 'FIVECOLTABLE',
                    selectedPartNumber: {},
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    };

    handlePartNumberSelect = obj => {

        const selObj = {
            partNumber: obj.partNumber,
            designTeamCode: obj.designTeamCode,
            manufacturingModule: obj.manufacturingModule,
            functionCodeId: obj.functionCodeId,
            functionCodeName: obj.functionCodeName,
            factoryCode: obj.factoryCode,
            productSeriesId: obj.productSeriesId,
            productSeriesName: obj.productSeriesName,
        };

        this.setState( {
            selectedPartNumber: selObj,
            isEdit: true,
            isAdd: false,
        } );

    };

    handleAsideUpdate = () => {

        if ( !this.state.isAdd ) {

            this.props.increaseCounter();
            editPartNumber( this.state.selectedPartNumber ).then( () => {

                this.props.increaseCounter();
                const obj = { ...this.state.searchKeyFields };
                if ( obj.functionCode === '' || obj.functionCode === undefined ) {

                    obj.functionCode = this.state.selectedPartNumber.functionCodeName;

                }
                getPartNumber( this.props.factoryCode, obj ).then( response => {

                    this.setState( {
                        functionCodes: response,
                        isEdit: false,
                        isAdd: false,
                    } );
                    this.props.decreaseCounter();
                    this.props.createSuccessMessage( 'Update Function Code Successful' );

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        } else {

            const obj = { ...this.state.selectedPartNumber };
            obj.factoryCode = this.props.factoryCode;
            this.props.increaseCounter();
            addPartToFunctionCode( obj ).then( () => {

                this.setState( {
                    isEdit: false,
                    isAdd: false,
                    searchKeyFields: {
                        productSeries: 0,
                        functionCode: '',
                        partNumber: '',
                        manufacturingModule: '',
                        designTeamCode: '',
                    },
                } );
                this.props.decreaseCounter();
                this.props.createSuccessMessage( 'Add New Function Code Successful' );

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    };

    handleAsideTextChange = event => {

        const curObj = this.state.selectedPartNumber;
        curObj[event.target.name] = event.target.value;
        this.setState( {
            selectedPartNumber: curObj,
        } );

    };

    handleDeleteClick = () => {

        this.setState( {
            confirmMessage: 'Are you sure you want to Delete?',
            confirmIsOpen: true,
            confirmTitle: 'Confirm Delete?',
        } );

    };

    handleConfirmClose = () => {

        this.setState( {
            confirmIsOpen: false,
        } );

    };

    onUploadReport = () => {

        this.setState( {
            modelIsOpen: true,
        } );

    }

    onUploadReportClose = () => {

        this.setState( {
            modelIsOpen: false,
        } );

    };


    downLoadReport = () => {

        this.props.increaseCounter();
        const productSeriesId = this.state.searchKeyFields.productSeries !== 0 ? this.state.searchKeyFields.productSeries : '';

        getAdminReport( 'functionCode', this.props.factoryCode, productSeriesId )
            .then( response => {

                getAdminReportDownload( response, 'function_code.csv' );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    handleConfirm = () => {

        this.props.increaseCounter();
        deletePartNumber( this.state.selectedPartNumber ).then( () => {

            this.setState( {
                confirmIsOpen: false,
            } );
            this.props.increaseCounter();
            const obj = { ...this.state.searchKeyFields };
            if ( obj.functionCode === '' || obj.functionCode === undefined ) {

                obj.functionCode = this.state.selectedPartNumber.functionCodeName;

            }
            getPartNumber( this.props.factoryCode, obj ).then( response => {

                this.setState( {
                    functionCodes: response,
                    isEdit: false,
                } );
                this.props.decreaseCounter();
                this.props.createSuccessMessage( 'Delete Function Code Successful' );

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    };

    updateProductSeriesDropdown () {

        this.props.increaseCounter();
        getProductSeries( this.props.factoryCode ).then( response => {

            const productSeriesDropdwnList = [];
            response.forEach( seriesList => {

                productSeriesDropdwnList.push( {
                    value: seriesList.productSeriesId,
                    label: seriesList.productSeriesName,
                } );

            } );
            this.setState( {
                productSeries: productSeriesDropdwnList,
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }
    handleDownloadClick = (fileName) => () => {
            console.log("fileName", fileName);
            
            this.props.increaseCounter();
    
            downloadSampleReports(fileName)
                .then(response => {
                    response.blob().then( blob => {
    
                        const url = window.URL.createObjectURL( blob );
                        const a = document.createElement( 'a' );
                        a.setAttribute( 'download', fileName+'.csv' );
                        a.href = url;
                        document.body.appendChild( a );
                        a.click();
                        a.parentNode.removeChild( a );
                
                    } );
                    this.props.decreaseCounter();
                })
                .catch(() => {
                    this.props.decreaseCounter();
                });
        }

    render () {

        return (
            <section>
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Function Code Maintenance

                        {!this.state.isAdd &&
                        <button className="report-button" type="button" onClick={this.downLoadReport} disabled={this.state.searchKeyFields.productSeries === 0}>Download Report</button>
                        }
                        {!this.state.isAdd &&
                        <button className="report-button" type="button" onClick={this.onUploadReport}>Upload Report</button> }
                        {/* <a title="Field having values can update only" href={CSVFile} className="upload-report-label" download="function_code.csv">Download Sample Report</a> */}
                        <a
                        className="upload-report-label"
                        title="Field having values can update only"
                        onClick={this.handleDownloadClick('function_code')}
                    >
                        Download Sample Report
                    </a>
                    </h2>
                </header>

                {!( this.state.isEdit && this.state.isAdd ) && (
                    <FunctionCodePanel
                        onTextChange={this.handleMainTextChange}
                        // factoryCode={this.props.factoryCode}
                        handleProductSeriesChange={this.handleProductSeriesChange}
                        productSeries={this.state.productSeries}
                        // handleEditClick={this.handleEditClick.bind(this.props)}
                        // handleSearchTableClick=
                        // {this.handleSearchTableClick.bind(this.props.selectedTeam)}
                        handleAddClick={this.handleAddClick}
                        handleCancelClick={this.handleCancelClick}
                        handleSearchClick={this.handleSearchClick}
                        searchKeyFields={this.state.searchKeyFields}
                    />
                )}

                <div className="section-with-aside">
                    {this.state.mode === 'TWOCOLTABLE' && (
                        <main>
                            <FCMTable
                                productSeriesList={this.state.functionCodes}
                                onFunctionCodeSelect={this.handleFunctionCodeSelect.bind( this )}
                            />
                        </main>
                    )}
                    {this.state.mode === 'FIVECOLTABLE' && (
                        <main>
                            <PartNumberSerchResultPanel
                                productList={this.state.functionCodes}
                                onPartNumberSelect={this.handlePartNumberSelect.bind( this )}
                                selectedPartNumber={this.state.selectedPartNumber}
                            />
                        </main>
                    )}


                    {( this.state.hasSearched || this.state.isEdit ) && (
                        <aside>
                            <FCMAside
                                factoryCode={this.props.factoryCode}
                                isEdit={this.state.isEdit}
                                isAdd={this.state.isAdd}
                                productSeries={this.state.productSeries}
                                onTextChange={this.handleAsideTextChange}
                                onCancel={this.handleCancelClick.bind( this.props )}
                                partNumber={this.state.selectedPartNumber}
                                onUpdate={this.handleAsideUpdate}
                                handleAsideTextChange={this.handleAsideTextChange}
                                handleProductSeriesChange={this.handleProductSeriesChange}
                                handleAsideProductSeriesChange={this.handleAsideProductSeriesChange}
                                onDelete={this.handleDeleteClick}
                            />
                            <ConfirmationModal
                                body={<div className="confirmation-messages">{this.state.confirmMessage}</div>}
                                header={this.state.confirmTitle}
                                isOpen={this.state.confirmIsOpen}
                                onCancel={this.handleConfirmClose.bind( this.props )}
                                onConfirm={this.handleConfirm.bind( this.props )}
                                onHide={this.handleConfirmClose.bind( this.props )}
                            />
                        </aside>
                    )}
                </div>
                {/* <MultipleEntryPopup
                    isOpen={this.state.modelIsOpen}
                    onClose={this.onUploadReportClose.bind( this.props )}
                /> */}

                    <FunctionCodeMultipleEntryPopup
                    isOpen={this.state.modelIsOpen}
                    onClose={this.onUploadReportClose.bind( this.props )}
                />

            </section>
        );

    }

}

FunctionCodeMaintenance.displayName = 'FunctionCodeMaintenance';
FunctionCodeMaintenance.propTypes = {
    factoryCode: PropTypes.string.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func.isRequired,
    reload: PropTypes.string.isRequired,
    updateReload: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
} );

const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );
export default connect(
    mapStateToProps, mapDispatchToProps,
)( FunctionCodeMaintenance );
// export default FunctionCodeMaintenance;
